/* eslint-disable @typescript-eslint/no-unused-vars */
import { codeSplit } from 'bernie-core';

export const ComponentLayoutMap = (moduleName) => {
  return codeSplit(() => import(/* webpackChunkName: "component-layout" */ `../component-layout`) as any);
};
